// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"PriceTableComponent_tableContainer__lsdsh","title":"PriceTableComponent_title__BIrqW","table":"PriceTableComponent_table__6Zbma"};